import { Box, Paper, Typography } from "@mui/material";
import { RecordsRelated } from "../../../components/recordsRelated/RecordsRelated";
import { ServicesPrescribedView } from "./treatment-prescription-view/ServicesPrescribedView";
import { useRecordsContext } from "../../../utils/useRecordsContext";
import { treatmentPrescriptionFieldsQuery, treatmentPrescriptionExtraOptions } from "./utils";
import { TreatmentPrescription as TreatmentPrescriptionType } from "./types";
import { ServicesProvidedView } from "./treatment-prescription-view/ServicesProvidedView";
import { useContext } from "react";
import { findFieldGroup } from "../../../utils/findField";
import { RecordContext } from "../../../components/record/Record";
import { FormFields } from "../../../components/entityForm/EntityForm";
import { EntityFormFieldSpecific } from "../../../components/entityForm/EntityFormFieldSpecific";
import { useForm } from "react-hook-form";
import { useField } from "../../../api/useField";
import { formatDateWithTime } from "../../../utils/dateUtils";

export const TreatmentPrescription = () => {
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <RecordsRelated
        entity="treatment_prescription"
        fieldsToQuery={treatmentPrescriptionFieldsQuery}
        fieldToFilter="treatment"
        recordsOptions={{
          relatedRecords: { hideCreationButton: true },
          extraOptions: {
            deep: {
              treatment: { sessions: { _limit: -1 } },
              ...treatmentPrescriptionExtraOptions.deep
            }
          }
        }}
        customComponentContent={<TreatmentPrescriptionView />}
        customComponentHeaderStyles={{ m: 0 }}
      />
    </Box>
  );
};

const TreatmentPrescriptionView = () => {
  const { items } = useRecordsContext("relatedRecords");
	const treatmentPrescription: TreatmentPrescriptionType = items?.[0];
  	const servicesPrescribedExist = treatmentPrescription?.services_prescribed?.length > 0;

  return (
		<Paper sx={{ display: "flex", flexDirection: "column", gap: 8 }} elevation={0}>
			<ServicesPrescribedView treatmentPrescription={treatmentPrescription} />
      <PrescriptionSentDate treatmentPrescription={treatmentPrescription} />
			<NextStepField />
			{servicesPrescribedExist && <ServicesProvidedView treatmentPrescription={treatmentPrescription} />}
		</Paper>
  );
};


const NextStepField = () => {
  const context = useContext(RecordContext);
  const entityForm = useForm<FormFields>();

  const item = context?.item;
  const { formatedField: nextStepField } = useField("treatments", "next_step");

  if (!item || !nextStepField) return null;

  const fieldGroupNextStep = findFieldGroup([nextStepField,...context?.formatedFields], "next_step", {fallbackHeaderName: "Próximo passo"});

  if (!fieldGroupNextStep) return null;

  return (
      <EntityFormFieldSpecific
        item={{ next_step: item?.next_step ?? "", id: item.id }}
        formatedFields={[ nextStepField, fieldGroupNextStep ]}
        entityName="treatments"
        entityForm={entityForm}
      />
  );
};


const PrescriptionSentDate = ({ treatmentPrescription }: { treatmentPrescription: TreatmentPrescriptionType }) => {
  const dateToDisplay = treatmentPrescription?.prescription_sent_date
    ? formatDateWithTime(treatmentPrescription?.prescription_sent_date)
    : "";

  return (
    <Box display="flex" flexDirection="column" gap={1} px={4}>
      <Typography variant="body1" color="primary.main">
        Data de envio
      </Typography>
      <Typography variant="body1">
        {dateToDisplay}
      </Typography>
    </Box>
  );
};
